export default __webpack_public_path__ + "static/media/Y1.c928d42a.jpg";